import { render, staticRenderFns } from "./SpecChatsPage.vue?vue&type=template&id=dbb3974e&scoped=true&lang=pug&"
import script from "./SpecChatsPage.vue?vue&type=script&lang=js&"
export * from "./SpecChatsPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecChatsPage.vue?vue&type=style&index=0&id=dbb3974e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb3974e",
  null
  
)

export default component.exports